import AppConstants from 'constants/AppConstants';
import protos from 'utils/consumerProto';

const { EmailOptInRequest } = protos;

export function setOptInStatus(optsInToEmail: boolean) {
  return {
    TockApi: {
      putProto: '/communication/optin',
      type: AppConstants.COMMUNICATION_OPT_IN_SET_STATUS,
      request: EmailOptInRequest.fromObject({
        optIn: optsInToEmail,
      }),
    },
  };
}
